import React from "react";

interface ClearIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const ClearIcon = (props: ClearIconProps) => {
  return (
    <svg
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={props.style}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="currentColor" cx="7" cy="7" r="7"></circle>
        <path
          d="M9.828 4.172a.5.5 0 0 1 0 .707l-2.122 2.12 2.122 2.122a.5.5 0 1 1-.707.707L7 7.706 4.88 9.828a.5.5 0 1 1-.707-.707L6.292 7l-2.12-2.12a.5.5 0 0 1 .707-.707l2.12 2.12 2.122-2.12a.5.5 0 0 1 .707 0Z"
          fill="#FFF"
        ></path>
      </g>
    </svg>
  );
};

export default ClearIcon;
